import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Images, useModal } from 'utils';
import { CustomDelete, CustomizedSwitch, SimpleTooltip } from 'components';
import { systemItemStyles } from './styles';
import { systemActions } from 'store';
import { ConnectZoom } from './modals';

const DISCONNECT_ZOOM = 'EDIT_ZOOM_STATUS';
export const Zoom = () => {
    const zoomConnection = useSelector((state) => state.system.zoomConnection);
    const googleMeetConnection = useSelector((state) => state.system.googleMeetConnection);
    const classes = systemItemStyles();
    const { open } = useModal();
    const dispatch = useDispatch();
    const [connect, setConnect] = useState(false);

    useEffect(() => {
        if (zoomConnection) {
            setConnect(zoomConnection?.isConnected);
        }
    }, [zoomConnection]);

    const handleConnect = () => {
        open(<ConnectZoom />);
    };

    const otherProviderConnected = googleMeetConnection?.isConnected;

    return (
        <div>
            <div className="office-ally-box">
                <div className="space-between" style={{ padding: 16 }}>
                    <div className={classes.iconAndTitle}>
                        <img src={Images.zoom} alt="officeAlly" />
                        <p>Zoom</p>
                    </div>
                    {zoomConnection?.isConnected ? (
                        <div className={classes.iconAndTitle} style={{ gap: 16, height: 32 }}>
                            <SimpleTooltip title={<p>{'Disconnect Zoom'}</p>} placement="top-start">
                                <CustomizedSwitch
                                    checked={connect}
                                    handleClick={() => {
                                        open(
                                            <CustomDelete
                                                text="Are you sure you want to disconnect Zoom? This action is not reversible."
                                                info="Disconnect Zoom"
                                                handleDel={() => dispatch(systemActions.editZoomStatus())}
                                                actionType={DISCONNECT_ZOOM}
                                                innerText={'Disconnect'}
                                                color={'blue'}
                                            />
                                        );
                                    }}
                                />
                            </SimpleTooltip>
                        </div>
                    ) : otherProviderConnected ? (
                        <SimpleTooltip title={<p>{'Disconnect Google Meet first'}</p>} placement="top-start">
                            <span>
                                <button disabled className={classes.connectBtn} style={{ opacity: 0.5 }}>
                                    Connect
                                </button>
                            </span>
                        </SimpleTooltip>
                    ) : (
                        <button onClick={handleConnect} className={classes.connectBtn}>
                            Connect
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};
